/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface TeamsProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Teams: React.FC<TeamsProps> = ({size, ...props}) => (
  <svg viewBox="0 0 40 40" fill="currentColor" width={ size || "40" } height={ size || "40" } {...props}>
    <path d="M19.0937 30H30.8985C32.4594 30 33 29.4778 33 28.5112 33 25.8071 29.909 22.0882 24.9961 22.0882 20.091 22.0882 17 25.8071 17 28.5112 17 29.4778 17.5405 30 19.0937 30zM25.0038 20.2219C27.0661 20.2219 28.8162 18.1849 28.8162 15.5517 28.8162 12.9669 27.0549 11 25.0038 11 22.945 11 21.1742 13.0033 21.1837 15.5708 21.1871 18.1849 22.9339 20.2219 25.0038 20.2219zM7.89241 30H15.5813C14.4885 28.3528 15.6899 25.0931 18 23.1991 16.8676 22.4333 15.3987 21.8624 13.5477 21.8624 8.96327 21.8624 6 25.4131 6 28.3394 6 29.3976 6.51009 30 7.89241 30zM13.5477 20.2267C15.4994 20.2267 17.1493 18.4003 17.1493 16.0599 17.1493 13.7546 15.4873 12 13.5477 12 11.6184 12 9.93769 13.79 9.94795 16.0776 9.9498 18.4003 11.6044 20.2267 13.5477 20.2267z"
      fill="#fff" />
  </svg>
);
Teams.displayName = 'Teams';
export default Teams;
/* tslint:enable */
/* eslint-enable */
